import {
    SET_AGENT,
    SET_AGENT_CONNECTION,
    SET_SELECTED_CONVERSATION,
    SET_CONVERSATIONS,
    SET_LOGING_IN_PROGRESS,
    SET_AGENT_CONVERSATIONS,
    SET_MESSAGES,
    ADD_MESSAGE,
    SET_SEARCH_TERM,
} from './_mutations'
export default {
    [SET_AGENT](state, agent) {
        state.agent = agent
    },
    [SET_SELECTED_CONVERSATION](state, conversation) {
        state.selectedConversation = conversation
    },
    [SET_CONVERSATIONS](state, conversations) {
        state.conversations = conversations
    },
    [SET_LOGING_IN_PROGRESS](state, value) {
        state.loginInProgress = value
    },
    [SET_MESSAGES](state, messages) {
        state.messages = messages
    },
    [ADD_MESSAGE](state, message) {
        state.messages.unshift(message)
    },
    [SET_SEARCH_TERM](state, term) {
        console.log({ SET_SEARCH_TERM: term })
        state.searchTerm = term
    },
    [SET_AGENT_CONNECTION](state, connection) {
        console.log('Setting agent connection:', connection)
        state.agentConnection = connection
    },
}
